import React, { useCallback, useMemo } from 'react';
import { mixpanel, bigQuery } from '@fiverr-private/obs';

export interface EventsContextValue {
  sourcePageKey: string;
  reportBQ: (guideKey: string, position?: number) => void;
  reportMixpanel: (eventName: string, payload: any) => void;
}

export const getGuideKeyFromUrl = (url) => url.split('/resources/guides/').pop().split('/').join('_');
const getBigQueryData = (sourcePageKey, guideKey, position) => ({
  group: 'user_action',
  type: 'clicked_on_related_guides',
  action: {
    type: 'click',
  },
  feature_name: 'related_guides',
  page: {
    name: sourcePageKey,
    element: {
      ...(position && { position }),
      text: guideKey,
    },
    component: {
      name: 'related_guides',
    },
  },
});

const reportBigQuery = (sourcePageKey, guideKey, position) =>
  bigQuery.send(getBigQueryData(sourcePageKey, guideKey, position));

const mixpanelService = {
  trackEvent: (eventName, payload) => mixpanel.track(eventName, payload),
};

export const EventsReportApiContext = React.createContext<EventsContextValue | null>(null);
export const useEventsContext = ({ sourcePageKey }) => {
  const reportBQ = useCallback(
    (guideKey, position) => reportBigQuery(sourcePageKey, guideKey, position),
    [sourcePageKey]
  );
  const reportMixpanel = useCallback((eventName, payload) => mixpanelService.trackEvent(eventName, payload), []);
  const eventsApi = useMemo(() => ({ reportBQ, reportMixpanel }), [reportBQ, reportMixpanel]);

  return { EventsReportApiContext, eventsApi };
};

export const mixpanelEventEnrichment = (categoryName, payload) => ({
  'Page name': 'Category',
  'Category Name': categoryName.split('_')[1],
  ...payload,
});
